export const pendingBookings = {
  configTitle: "Configura las reservas directas",
  configText:
    "Activa las reservas directas para gestionar aquí los pagos pendientes y las solicitudes de reserva de tus huéspedes.",
  reminderLabel: "Recordatorio:",
  reminderReasonIntent: "cobro pendiente de",
  reminderReasonUnassigned: "asignar habitación a",
  reminderReasonRequest: "solicitud por revisar de",
  combined: "Combinada · {count} hab",
  expired: "Expirado",
  toastSuccessTitle: "Éxito",
  toastErrorTitle: "Error",
  toastWarningTitle: "Aviso",
};
